let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page011_game4/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 379,
      y: 138,
    },
  },
  activeArea: {
    width: 60,
    height: 60,
    fontSize: 39,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      animation: true,
      id: '1',
      textObj: {
        text: 'Sposób 1. Kliknij dwukrotnie w ikonę skrótu do programu Paint na <i>Pulpicie</i>.',
      },
      audio: {
        src: 'games/page011_game4/audio/z5s11-a1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 494,
        y: 467,
      },
    },
    {
      id: '2',
      textObj: {
        text: 'Sposób 2. Kliknij w ikonę programu Paint <br/>na dolnym <i>Pasku zadań</i>.',
      },
      audio: {
        src: 'games/page011_game4/audio/z5s11-a2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 694,
        y: 917,
      },
    },
  ],
};
export default elements;
